/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Applies_ToInputs */

const en_admin_discounts_applies_to = /** @type {(inputs: Admin_Discounts_Applies_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applies to`)
};

const de_admin_discounts_applies_to = /** @type {(inputs: Admin_Discounts_Applies_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gilt für`)
};

const es_admin_discounts_applies_to = /** @type {(inputs: Admin_Discounts_Applies_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se aplica a`)
};

const fr_admin_discounts_applies_to = /** @type {(inputs: Admin_Discounts_Applies_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'applique à`)
};

const nl_admin_discounts_applies_to = /** @type {(inputs: Admin_Discounts_Applies_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van toepassing op`)
};

/** @type {(inputs: Admin_Discounts_Applies_ToInputs) => LocalizedString} */
const it_admin_discounts_applies_to = en_admin_discounts_applies_to;

/** @type {(inputs: Admin_Discounts_Applies_ToInputs) => LocalizedString} */
const pt_br2_admin_discounts_applies_to = en_admin_discounts_applies_to;

/** @type {(inputs: Admin_Discounts_Applies_ToInputs) => LocalizedString} */
const pl_admin_discounts_applies_to = en_admin_discounts_applies_to;

/** @type {(inputs: Admin_Discounts_Applies_ToInputs) => LocalizedString} */
const hu_admin_discounts_applies_to = en_admin_discounts_applies_to;

/** @type {(inputs: Admin_Discounts_Applies_ToInputs) => LocalizedString} */
const ro_admin_discounts_applies_to = en_admin_discounts_applies_to;

/**
* | output |
* | --- |
* | "Applies to" |
*
* @param {Admin_Discounts_Applies_ToInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_applies_to = /** @type {((inputs?: Admin_Discounts_Applies_ToInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Applies_ToInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_applies_to(inputs)
	if (locale === "de") return de_admin_discounts_applies_to(inputs)
	if (locale === "es") return es_admin_discounts_applies_to(inputs)
	if (locale === "fr") return fr_admin_discounts_applies_to(inputs)
	if (locale === "nl") return nl_admin_discounts_applies_to(inputs)
	if (locale === "it") return it_admin_discounts_applies_to(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_applies_to(inputs)
	if (locale === "pl") return pl_admin_discounts_applies_to(inputs)
	if (locale === "hu") return hu_admin_discounts_applies_to(inputs)
	return ro_admin_discounts_applies_to(inputs)
});
export { admin_discounts_applies_to as "admin.discounts.applies_to" }